import Tag from '../reusable/Tag';

export type SjwPhotoUploadStatusValue = 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETE';

interface SjwPhotoUploadStatusProps {
  status: string | null;
  size?: 'small' | 'medium';
  className?: string;
}

export const getSjwPhotoUploadStatusDisplay = (
  status: string | null
): { text: string; type: 'pending' | 'completed' | 'progress' } => {
  switch (status) {
    case 'IN_PROGRESS':
      return { text: 'In progress', type: 'progress' };
    case 'COMPLETE':
      return { text: 'Completed', type: 'completed' };
    case 'NOT_STARTED':
    default:
      return { text: 'Not started', type: 'pending' };
  }
};

const SjwPhotoUploadStatus = ({ status, size = 'small', className }: SjwPhotoUploadStatusProps) => {
  const { text, type } = getSjwPhotoUploadStatusDisplay(status);
  return <Tag type={type} text={text} size={size} className={className} />;
};

export default SjwPhotoUploadStatus;
